import React, { FC } from 'react'
import { ButtonContainer, CardWrapper, Data, DataContainer, Title } from './MapLotCard.style'
import { CarpayLot } from '@customTypes/carpayLot.interface'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { useTranslation } from 'react-i18next'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'

interface Props {
    lot: CarpayLot
    onLotClick: (lot: CarpayLot) => void
}

const MapLotCard: FC<Props> = ({ lot, onLotClick }) => {
    const { t } = useTranslation()

    const { name, address } = lot
    const street = address.split(',')[0] || ''
    const city = address.split(',')[1] || ''

    const onClick = () => {
        onLotClick(lot)
    }

    return (
        <CardWrapper onClick={onClick}>
            <DataContainer>
                <Title>{name}</Title>
                <Data>{street}</Data>
                <Data>{city}</Data>
            </DataContainer>
            <ButtonContainer>
                <Button
                    $size={BUTTON_SIZE.small}
                    $kind={BUTTON_KIND.primary}
                    onClick={onClick}
                    overrides={{ BaseButton: { style: { maxWidth: '9.7rem', fontSize: '1.4rem' } } }}
                >
                    {t('carpay.notFound.search.choose')}
                </Button>
            </ButtonContainer>
        </CardWrapper>
    )
}

export default MapLotCard
